export const sharePacks = {
  shippingFields: {
    title: 'Where are we sending this free gift?',
    subtitle:
      'Your friend will receive their AG1 Travel packs in 3 - 5 business days. You can track delivery in your order history.',
    email: 'Friends Email',
    giftMessage: 'Gift Message (500 character limit)',
    country: 'Country/region',
    firstName: 'First Name',
    lastName: 'Last Name',
    addressLine1: 'Address',
    addressLine2: 'Apartment, Suite, Etc (optional)',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    phone: 'Phone',
    submitButtonText: 'Save',
    cancelButtonText: 'Cancel',
    label: 'Send as a gift',
    caption: `
    <p>By placing this order, you agree to the 
      <a href="https://drinkag1.com/terms-and-conditions" target="_blank" aria-label="Terms of Service (Opens in a new tab)" rel="noopener">Terms of Service</a> 
      and&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" aria-label="Privacy Policy (Opens in a new tab)" rel="noopener">Privacy Policy</a>.
    </p>
  `
  },
  commonError: 'Something went wrong. Please, try again later.',
  title: 'Share FREE AG1 Travel Packs with your friends:',
  subtitle: 'Give them a taste of how good it feels to own your health, with a 5-pack — on us.*',
  disclosure:
    '*Limited to active subscribers only. Free AG1 Travel Packs offer is valid for 30 days after being notified. Free AG1 Travel Packs are non-transferrable, must be redeemed within the member portal, and can only be sent to addresses in the USA. Limit of three 5ct AG1 Travel Packs per qualified customer.',
  status: {
    shared: 'You have shared all your packs',
    expired: 'Share Free Packs pilot program has ended, check back in for more!',
    limited: 'Limited Time Program',
    expiring: 'Free Travel Packs offer will expire {{date}}.'
  },
  button: {
    share: 'Share 5 Travel Packs',
    expired: 'Expired',
    viewOrder: 'View Order',
    shared: 'Shared'
  },
  modal: {
    head: 'Share Free Travel Packs',
    title: 'Where are we sending this free gift?',
    subtitle:
      'Your friend will receive their AG1 Travel packs in 3 - 5 business days. You can track delivery in your order history.'
  },
  checkout: {
    success: 'Your order has been successfully created.'
  },
  subscriptionFreeGiftName: 'Share Free Packs',
  buttonTrack: 'Track Order',
  freeGiftPrice: 'Free',
  subscriptionNameLabel: 'Order Type'
};
